import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteGuard } from "@/components/auth/RouteGuard";

export const Route = createFileRoute("/_authenticated/transfers")({
  component: () => (
    <RouteGuard module="transfers"><Outlet /></RouteGuard>
  ),
});
